export default __webpack_public_path__ + "static/media/misc-bathtubA.ced36e1c.jpg";